export default __webpack_public_path__ + "static/media/withdraw_gift.9dfe65fd.svg";